module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-004"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_n",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', {
    staticClass: "mev3"
  }, [_vm._v("Chapter")]), _c('span', {
    staticClass: "mev4"
  }, [_vm._v("4")])]), _c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Conclusions and Recommendations")])]), _c('div', {
    staticClass: "chapeau"
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Here’s the short form: The conclusions are the heart and soul of your report, and the recommendations may hold the key to future projects. Everything you write in the rest of the report will provide evidence to support and explain your conclusions.")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Since the conclusions are critical to the content of your report, write them first. That means you will need to finish the project so you will know what your results are and what they mean before you draft the conclusions. Once you have conclusions, writing the report will be fairly straightforward: In each section, you will use the conclusions as a guide for what to write.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("For the purposes of this book, the "), _c('i', [_vm._v("results ")]), _vm._v("of a technical project state the outcomes of tests or calculations, usually with little or no interpretation. For example, in our flowmeter project, we measured flow at rates from 3 to 10 ft/min and collected data from each test run. We can look at those data and see how many times the new flowmeter was accurate at each rate. The "), _c('i', [_vm._v("result ")]), _vm._v("of the tests is the number of times the tool measured the flow accurately, and at a technician’s level, that result may be all that needs reporting.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But for a more formal report, you need to present more than just the straightforward results; you need to put them into context. Since the objective of our work was to measure flow as low as 5 ft/min, we might say our project was "), _c('i', [_vm._v("unsuccessful ")]), _vm._v("because the tool only captured that low rate in one test out of ten. Or we might say that the tool was accurate to 7 ft/min but not at lower rates. "), _c('i', [_vm._v("Unsuccessful ")]), _vm._v("and "), _c('i', [_vm._v("accurate ")]), _vm._v("give the readers our "), _c('i', [_vm._v("interpretation ")]), _vm._v("of the results beyond the data we collected. The result plus the interpretation makes it a conclusion.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Recommendations may go one step further by suggesting a course of action that may lead to more projects for you or work for your company. "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("For example, we might "), _c('i', [_vm._v("recommend ")]), _vm._v("that our clients test our new design at one of their sites to determine whether it gives them more meaningful measurements than their current tool is giving.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-012"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Three Kinds of Conclusions"), _c('br'), _vm._v(" (and Some Pseudoconclusions)")]), _c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_vm._v("Proper conclusions normally fall into one of three categories:")]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Generalizations ")]), _vm._v("provide insights based on multiple pieces of evidence.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Evaluations ")]), _vm._v("provide some interpretation of the results in terms that rely on context for meaning.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Estimates ")]), _vm._v("provide values that cannot be directly measured.")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("What they should not be are pseudoconclusions, which cannot be supported by the project’s results:")]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Statements of facts or common knowledge ")]), _vm._v("or other information that is readily available from other sources")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_c('b', [_vm._v("Conjecture or speculation ")]), _vm._v("about future effects or importance of the results")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-009"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Generalizations")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Generalizations are observations about results that you can make with confidence because you have seen multiple instances of the result. For example, if we say our flowmeter is accurate to 7 ft/min in liquids in some specified range of temperatures and viscosities, we can be increasingly confident in that claim if we have run multiple tests at each viscosity and temperature. Or we might have changed flow rate gradually through several fluids of increasing temperature and decreasing velocity and seen a consistent-enough trend in results to trust our claim. After all, a single data point may not be at all representative of the typical behavior of the tool.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Whichever approach we have taken, observing a large collection of data or results gives us more confidence in our results, and we can express that confidence as a generalization:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_justif last"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_vm._v("The tool performed accurately within 1% of the predetermined flow rate over 10 test runs at each combination of viscosity and temperature.")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Note that the generalization essentially summarizes the results of multiple tests. Some projects are too time-consuming or complex to permit more than a single test or test run, so you may not be able to reach the level of generalizations because you cannot collect enough data. In those cases, you may be able to compare your results with previous, similar projects, thus giving yourself at least some grounds for interpretation of your results.")])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-010"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Evaluations")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Evaluations contain words that depend on context for meaning. For example, in our scenario above, we said that our tool is accurate to 7 ft/min. For some purposes, the tool might be considered accurate if it is within 10% of the target rate; for others, it might not be considered accurate if it is even 1% off. Because the word "), _c('i', [_vm._v("accurate ")]), _vm._v("has a different definition based on circumstance, the conclusion needs to include context. So we might say:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_justif last"
  }, [_vm._v("The tool is accurate to 7 ft/min, measuring within 5% of that rate 9 out of 10 times with liquids between "), _c('i', [_vm._v("x")]), _vm._v("°F and "), _c('i', [_vm._v("y")]), _vm._v("°F and "), _c('i', [_vm._v("m ")]), _vm._v("and "), _c('i', [_vm._v("n ")]), _vm._v("cp.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("To see how important context can be to the meaning of words, consider the word "), _c('i', [_vm._v("fast")]), _vm._v(". The difference in a fast runner and a fast car can be hundreds of miles per hour. And whether a car is fast may depend on whether the car is on a racetrack or in a school zone, or whether the weather is clear or rainy. A fast calculation may take seconds or days, depending on the complexity of the calculation and the data it requires.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("These descriptive words also lend interpretation to the conclusions, so a conclusion that includes one of them gives readers at least some sense of the value of the results. They also help your readers see that your report is more sophisticated than the technologist’s report that merely reported the results.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Note that this example blends evaluation with generalization. That is common in conclusions because the combination often provides a more meaningful interpretation of the results than either used alone.")])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-011"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Estimates")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As a rule, estimates of measurable data points don’t belong in the conclusions. For example, even if you didn’t actually pull out a ruler and measure the length of a pipe, you could have, so your “estimated length” is only a guess, not a supportable conclusion.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But in some situations, we simply can’t directly measure important values, so we determine them from calculations. These calculations are interpretations of data points that may have come from indirect measurements, but they do not represent direct readings from a measuring tool. Because they require interpretation, these estimates do qualify for inclusion in our conclusions list.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Petroleum engineers make these kinds of estimates routinely. For example, they must continually calculate the amount of oil or gas in a reservoir, but the reservoir may be thousands of feet below the earth’s surface, irregularly shaped, and holding its fluids in microscopic openings in rock. No known instrument can get into the formation to measure its capacity to hold fluids, so the engineers use sophisticated tools and complex calculations to estimate amounts. These amounts are critical to production operations, so they are valuable as conclusions. Other disciplines have similar challenges, and the values that result from these calculations are often important in the conclusions.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("So we cannot “estimate” the angle of the impeller blades on our new flowmeter because we have tools that can measure that angle. But we might extrapolate other conditions where our tool might be accurate from the data we have about where it has been accurate:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_justif last"
  }, [_vm._v("Because the tool is accurate to 7 ft/min, measuring accurately 9 out of 10 times with liquids between "), _c('i', [_vm._v("x")]), _vm._v("°F and "), _c('i', [_vm._v("y")]), _vm._v("°F and "), _c('i', [_vm._v("m ")]), _vm._v("and "), _c('i', [_vm._v("n ")]), _vm._v("cp, we can project that it will also be accurate with fluids between "), _c('i', [_vm._v("p")]), _vm._v("°F and "), _c('i', [_vm._v("q")]), _vm._v("°F and "), _c('i', [_vm._v("r ")]), _vm._v("and "), _c('i', [_vm._v("s ")]), _vm._v("cp.")])])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-012"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Pseudoconclusions")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Pseudoconclusions are statements that may seem to be conclusions but don’t actually meet the criteria for generalizations, evaluations, or estimates. They may include statements of common knowledge:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_justif last"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_vm._v("Measuring fluid flow at low speeds is becoming increasingly important.")])])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v(". . . simple statements of fact from the project accomplishments:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_justif last"
  }, [_vm._v("We have designed a new flowmeter tool.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v(". . . or other information that is related to but not an outcome of the project:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_justif last"
  }, [_vm._v("Fluid flow rates are slowing down in the client’s system.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("All these statements are relevant to the project, but they were not outcomes of the project; instead, they were part of the problem or situation that led to the project.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Also beware of conjecture or speculation in the conclusions list. These statements make claims about future effects or values of the project’s outcomes on a scale larger than the project alone. For example:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_justif last"
  }, [_vm._v("We have shown that our flowmeter is an improvement over existing tools and will improve flow measurement as reservoirs deplete.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Your company might decide that the new tool is too complex or inefficient to manufacture, so it might not even become available. The tool might come onto the market at the same time as another, more efficient or accurate tool that will make this one obsolete before it goes into production. Or the client might decide their need is not great enough to invest in the tool at this time. So any claim about its future is likely without merit.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("More important, none of these claims is supportable by evidence from this project. Since the task of the rest of your report is to provide "), _c('i', [_vm._v("evidence ")]), _vm._v("for each of its conclusions, these statements are simply inappropriate for the list.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-013"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Formulating the Conclusions")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("As you begin to develop your conclusions, keep in mind that you will need to provide evidence in the report to support every item on the list. "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  }, [_vm._v("If you can’t support it with evidence, you can’t put it on the list. In the case of our flowmeter project, for example, if we are going to project additional conditions for use, we can’t include those projections in the conclusions unless we show how we calculated them:")])]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_vm._v("If we don’t have the calculations, we don’t have evidence, so we don’t have a conclusion.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_vm._v("If we do show the calculations, we can show our evidence, so we can include the projections as a part of the conclusions.")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("That means that any statement about how a tool will be used in the future, how a process will benefit the company, or how comfortable the project team was with the new workflow can’t be listed as a project conclusion. You can make these statements before your bullet list of conclusions, but you shouldn’t include them as conclusions themselves. See the notes on pseudoconclusions in this section.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("To decide where to begin to formulate the conclusions, first look at the situation or problem or assignment that started you on the project. Your most important conclusion will most likely be a response to that situation, but that will change based on your audience.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In Archimedes’s case, for example, the assignment from the king was to determine whether his crown contained all the gold he had given to the court jeweler, and the main conclusion for the king would have been that it did not. But for engineering practice, that conclusion is not the important one. The important outcome is the concept of displacement. If the story is right, Archimedes’s law didn’t come from the assignment he was given, but from the situation that Greeks didn’t have a way to measure the volume of irregularly shaped objects.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("So in his report to the king, Archimedes’s main conclusion (and maybe his only conclusion) would have been either:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_justif last"
  }, [_vm._v("The crown does not contain the amount of gold given to the jeweler.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v(". . . or:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_justif last"
  }, [_vm._v("The crown does not contain the appropriate amount of gold.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In our version of the story, Archimedes ran numerous tests on multiple objects to determine that, so if we are analyzing his conclusions, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "title": "25"
    }
  }, [_vm._v("we can accept the first option as a generalization because it was the outgrowth of all those tests. If he wrote it the second way, it’s an evaluation because the word "), _c('i', [_vm._v("appropriate ")]), _vm._v("depends on whether the king was willing to make any allowance at all for loss during the smelting process.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("If Archimedes knew that the king was interested in science, he might also have included his finding that the volume of objects can be determined by displacement, but otherwise that might not even appear in his report.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("On the other hand, when Archimedes made his report to the Greek Academy of Science (GAS), he would likely have ignored his purpose altogether in his conclusions, because although his purpose was to find out how much gold was in the crown, displacement was the much more important concept for the scientists. In fact, since the earliest recorded versions of the crown story are a couple of hundred years after Archimedes’s time, we can be certain that he wisely didn’t mention the crown at all:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_justif last"
  }, [_vm._v("The volume of an irregularly shaped object can be found by measuring water displacement.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In our flowmeter example, our client who wanted to measure flow at 5 ft/min needs to know this conclusion:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_justif last"
  }, [_vm._v("The redesigned tool can work successfully (evaluation) at rates as low as 7 ft/min, but has not yet achieved the target rate of 5 ft/min.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The client may also want to know as a conclusion the cost to purchase the new tool and whether it will be economical to implement it in their operations. Depending on their interest in the design factors, they may or may not care whether we include conclusions about the changes we made from the older tool; their greater concern is the new one.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The project supervisor will be interested in all the work, so the conclusions of that report will certainly respond to the need to increase accuracy at lower rates and the efficacy of changes we made in design and materials:")]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_vm._v("The tool is accurate to 7 ft/min, measuring accurately 9 out of 10 times with liquids between "), _c('i', [_vm._v("x")]), _vm._v("°F and "), _c('i', [_vm._v("y")]), _vm._v("°F and "), _c('i', [_vm._v("m ")]), _vm._v("and "), _c('i', [_vm._v("n ")]), _vm._v("cp.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "title": "26"
    }
  }, [_vm._v("The change in angle of the impeller blades appears to have reduced resistance to flow at the low rate.")])])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_vm._v("The new alloy has shown excellent resistance to wear between the axle and hub, which can extend the life of the mechanism.")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In the case of a really large project like our mooring systems design, it’s probably appropriate to have a list of several conclusions for each component of the project: evaluating software, building a new simulator, and testing a set of design options. For our professional organization meeting, the project might be broken up to create three different papers, each one covering a different component of the project and focusing on its conclusions. Otherwise, we might select one or two major conclusions from each part of the project to keep our list from becoming unwieldy. For the company or agency that funded the project, we will need a single report, which may be quite long and will need enough conclusions to communicate that the cost of the project was worth the investment.")])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-014"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Formatting the Conclusions")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Readers who are in a hurry may look to the conclusions right after they read the title or abstract of the technical paper. (That’s why the ACID approach to writing serves them well.) And when they find them, readers generally are not interested in plowing through a long list or dense text to find out what the project accomplished.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("To serve the readers, keep your conclusions list and each item within it short.")]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_vm._v("If you have only one or two important conclusions, format them as short paragraphs (one or two sentences).")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_vm._v("If you have from three to five conclusions, format them as a numbered or bulleted list, and limit each item to one or two sentences.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_vm._v("If your list is longer than five conclusions, consider whether each of them meets the criteria for generalizations, evaluations, or estimates. If not, see if you can restate them so they do.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_vm._v("If you can’t restate or delete an item, see if you can combine it with another one. You might find that a pseudoconclusion provides "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "title": "27"
    }
  }, [_vm._v("excellent explanation for another conclusion. For example, let’s say you have one bullet point that says:")])])])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_justif last"
  }, [_vm._v("The flowmeter captures flow accurately at rates as low as 7 ft/min. (a generalization/evaluation)")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v(". . . and another that says:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_justif last"
  }, [_vm._v("The meter was tested on fluids at ranges of temperatures and viscosities from "), _c('i', [_vm._v("x ")]), _vm._v("to "), _c('i', [_vm._v("y ")]), _vm._v("degF and from "), _c('i', [_vm._v("m ")]), _vm._v("to "), _c('i', [_vm._v("n ")]), _vm._v("cp. (pseudoconslusion, a statement of fact)")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Instead of keeping the two very short bullet points, you can combine them into one longer one:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_justif last"
  }, [_vm._v("After testing fluids at ranges of temperatures and viscosities from "), _c('i', [_vm._v("x ")]), _vm._v("to "), _c('i', [_vm._v("y")]), _vm._v("°F and from "), _c('i', [_vm._v("m ")]), _vm._v("to "), _c('i', [_vm._v("n ")]), _vm._v("cp, the flowmeter was found to capture flow accurately at rates as low as 7 ft/min.")])]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_vm._v("If your project is complex and you can’t feel comfortable with a list as short as five conclusions, see if you can break the list into segments representing different parts of the project so that you have no more than five conclusions per segment. Then you can handle each segment as a separate list in your final conclusions.")])])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-013"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Introduce your conclusions where they are appropriate.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("If you have at least three conclusions, especially if your project is complex, you may want to introduce the conclusion section with a short statement to focus the readers on the accomplishments of the project. (Remember that they may not have read the rest of the report, so they may need a little orientation to it.) For example, Archimedes could introduce his GAS paper’s conclusions by saying:")]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_justif last"
  }, [_vm._v("The concept of displacement defined in this paper could have important implications for both science and commerce.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("That statement borders on conjecture, which is not appropriate for the conclusions themselves, but it’s okay to use something like this in an introductory statement to the conclusions.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "title": "28"
    }
  }, [_vm._v("The conclusions for our mooring systems project report might begin with a statement along these lines:")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_justif last"
  }, [_vm._v("With the growing focus on offshore facilities, operators need to improve the quality and efficiency of facility safety design. This project addressed both of those issues, leading to the following conclusions.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("That statement begins with common knowledge about the status of offshore work and a simple statement of fact about the project, but like the previous statement, it’s okay as an introduction to the conclusions list.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In fact, since the mooring systems project was so complex, its conclusions could be divided into three or four groups of three to five conclusions each, and each group could begin with a similar statement. Beware, however, that most readers don’t have the time or energy to read such long reports (many who read it at all will stop after the conclusions), so to serve most of them, you should keep the list as short as you responsibly can.")])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-014"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Include figures if they serve your purpose well.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("While graphs and tables rarely appear in the conclusions list, including relevant details for comprehension can take precedence in some cases. And just as you’re able to include pseudoconclusions as an introductory statement to the conclusions list or as an introductory clause to a specific conclusion, you can appropriately work in a figure.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In fact, if you think your readers will benefit from seeing a specific graph or table in the conclusions, make sure it’s succinct, providing only a summary of the information that you may have presented in a more detailed version in the body of the report.")])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-015"
    }
  }, [_c('h3', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Order conclusions to meet your reader’s needs.")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Once you have defined the conclusions you need to address in the report, organize them in order of importance to the readers. Remember that your readers aren’t interested in the order you did the work; they are interested in solutions to problems or suggestions for better ways of doing business. Keep in mind that for different audiences, you will probably present your list of conclusions in a different order.")])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-015"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "title": "29"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Recommendations")]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In a report for a client company, recommendations can be valuable in continuing the business relationship beyond the current project. For example, in our flowmeter project, the client asked us to develop a tool that met a certain standard. While we weren’t successful to the level they wanted, we do have a tool that may be able to improve their measurements over the near term, and our recommendation that they implement the tool in their operations may convince them to buy the new model.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In the mooring systems project, our recommendation to members of the professional organization to use our new simulator in offshore facility design could increase sales of the new tool. Or our recommendation to continue the design to include other elements besides the mooring line could encourage others to fund the additional research. Or our recommendation to our own company to use our new design could affect the company’s operations.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Although recommendations do not require the direct evidence that conclusions require, they certainly should be clear outgrowths of the project work.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Recommendations can be formatted with the conclusions or as a separate section.")]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_vm._v("If you have only one conclusion and one recommendation, you might want to title the section "), _c('i', [_vm._v("Conclusion and Recommendation ")]), _vm._v("and put the conclusion in the first paragraph and the recommendation in the second.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_vm._v("If you have three or four conclusions and recommendations combined, you might format them in a bullet list with an introductory statement to assure your readers that they are getting both conclusions and recommendations.")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_vm._v("If you have more conclusions and recommendations (but optimally, not more than five of either), you might have separate introductory statements for each list. Better yet, you might separate the lists under two subheadings, one for the conclusions and one for the recommendations. You can still use introductory statements for each list if you want to.")])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "title": "30"
    }
  }, [_vm._v("Consider the audience and purpose of your report. If your readers need your recommendations more than your conclusions, you might consider putting them first. And if you can serve their needs better by placing the conclusions and recommendations near the beginning of the paper as in our ACID approach to formatting, consider moving them there.")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-016"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Critiquing the Conclusions and Recommendations")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("After you have drafted your conclusions, see if they meet the standards laid out here:")]), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_vm._v("Does each conclusion meet the standards of evaluations, generalizations, or estimates? If not, could the pseudoconclusions be omitted or presented as support for conclusions that do meet those standards?")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_vm._v("If you have more than one or two conclusions or recommendations, have you formatted them in a bulleted or numbered list? (If you have only one or two, have you presented them in a list or in short, clear paragraphs?)")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_vm._v("Have you limited your list to four or five really significant conclusions or recommendations, or have you broken the list into subsections that correlate with various parts of the project?")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_vm._v("Have you organized the conclusions and recommendations to present the most important ones at the top of the list or subsection?")])]), _c('li', [_c('p', {
    staticClass: "liste_txt_courant_ssalinea"
  }, [_vm._v("Have you presented support information succinctly? This might mean a brief introduction to the conclusions section, a single sentence or two joined to individual conclusions, or a succinct table or graph that would be helpful for your readers.")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d24b444","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap4.vue
// module id = 78
// module chunks = 0